var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import EdButton, { EdALinkButton, } from "@frameworks/web/components/generic/edbutton/edButton";
import GenericTable from "@frameworks/shared-library/components/GenericTable";
import di from "@frameworks/salesjourney/components/Features/LeadDashboard/di/serviceLocator";
import { useSelector } from "react-redux";
import Loader from "@frameworks/shared-library/components/Loader";
import ErrorNotification, { ErrorDisplayType, } from "../Generic/ErrorNotification";
import { downloadBase64Image, getImageFileExtension, } from "@frameworks/salesjourney/utils/genericMethods";
import Errormsg from "@frameworks/web/components/generic/errorMsg";
import ImagePopup from "./ImagePopup";
export var overviewDetails = [
    { title: "Name", value: "Rohit Sharma" },
    {
        title: "Email ID",
        value: React.createElement("span", { className: "underline" }, "rohit.sharma@infovisions.com"),
        tag: "DND",
    },
    { title: "Mobile", value: "9867806757" },
    { title: "Status", value: "Verified" },
    { title: "Last Engagement Date", value: "24 Jan 2023" },
    {
        title: "Profiler",
        value: "45%",
        link: (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", value: "View Profile" })),
    },
];
var ProfileOverview = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var _k = __read(useState([]), 2), base64StringArray = _k[0], setBase64String = _k[1];
    var _l = __read(useState([]), 2), displayList = _l[0], setDisplayList = _l[1];
    var _m = __read(React.useState(false), 2), profilePicError = _m[0], setProfilePicError = _m[1];
    var _o = __read(useState(""), 2), imgType = _o[0], setImgType = _o[1];
    var _p = __read(useState(), 2), selectedFilesLength = _p[0], setSelectedFileLength = _p[1];
    var _q = __read(useState(false), 2), isReadyToUpload = _q[0], setIsReadyToUpload = _q[1];
    var _r = __read(useState(false), 2), openImageOptions = _r[0], setOpenImageOptions = _r[1];
    var toBase64 = function (file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            var base64String = {
                base64String: reader.result,
                file: file,
            };
            var base64Display = {
                base64String: reader.result,
            };
            setDisplayList(function (_a) {
                var _b = __read(_a), displayList = _b.slice(0);
                displayList.push(base64Display);
                return displayList;
            });
            setBase64String(function (_a) {
                var _b = __read(_a), base64StringArray = _b.slice(0);
                base64StringArray.push(base64String);
                return base64StringArray;
            });
        };
        reader.onerror = function (error) { };
    };
    var onSelectFile = function (e, photoType, forClientProfilePic) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedFiles_1, isAllFileSizeValid_1, totalSize, selectedFiles, clientProfilePic_1, reader_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setProfilePicError(false);
                    return [4 /*yield*/, setImgType(photoType)];
                case 1:
                    _a.sent();
                    if (!forClientProfilePic) {
                        selectedFiles_1 = Array.from(e.target.files);
                        if ((selectedFiles_1 === null || selectedFiles_1 === void 0 ? void 0 : selectedFiles_1.length) > 0) {
                            isAllFileSizeValid_1 = true;
                            totalSize = selectedFiles_1 === null || selectedFiles_1 === void 0 ? void 0 : selectedFiles_1.reduce(function (totalSize, file) {
                                if (file.size > 5242880) {
                                    isAllFileSizeValid_1 = false;
                                }
                                return (totalSize += file.size);
                            }, 0);
                            if (isAllFileSizeValid_1 && totalSize < 26214400) {
                                setSelectedFileLength(selectedFiles_1 === null || selectedFiles_1 === void 0 ? void 0 : selectedFiles_1.length);
                                selectedFiles_1.map(function (record, id) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        if (selectedFiles_1.length - 1 === id) {
                                            setIsReadyToUpload(true);
                                        }
                                        toBase64(record);
                                        return [2 /*return*/];
                                    });
                                }); });
                            }
                            else {
                                setOpenImageOptions(false);
                                setProfilePicError(true);
                            }
                        }
                    }
                    else {
                        selectedFiles = e.target.files;
                        clientProfilePic_1 = selectedFiles[0];
                        if (clientProfilePic_1.size > 5242880) {
                            setOpenImageOptions(false);
                            setProfilePicError(true);
                        }
                        else {
                            setProfilePicError(false);
                            reader_1 = new FileReader();
                            reader_1.readAsDataURL(clientProfilePic_1);
                            reader_1.onload = function () {
                                return __awaiter(this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, uploadImagesForClient("", [
                                                    {
                                                        imageString: reader_1.result.split(",")[1],
                                                        fileName: clientProfilePic_1.name,
                                                        uploadType: photoType,
                                                    },
                                                ])];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            };
                            reader_1.onerror = function (error) { };
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var userId = useSelector(function (state) { var _a, _b; return (_b = (_a = state.Profile.ProfileDetails.reducersData.data) === null || _a === void 0 ? void 0 : _a.profileDetails) === null || _b === void 0 ? void 0 : _b.userId; });
    var clientProfileDetails = useSelector(function (state) {
        return state.Lead.ClientProfileDetails.reducersData.clientProfileDetails;
    });
    var clientPurchaseHistory = useSelector(function (state) {
        return state.Lead.PurchaseHistory.reducersData.clientPurchaseHistoryData;
    });
    var clientPurchaseHistoryCommonData = useSelector(function (state) { return state.Lead.PurchaseHistory.commonData; });
    var clientProfileCommonData = useSelector(function (state) { return state.Lead.ClientProfileDetails.commonData; });
    var getClientPurchaseHistory = function () {
        var req = {
            clientId: props.clientId,
            page: "1",
            pageSize: "200",
        };
        di.leads.getPurchaseHistoryActions(req);
    };
    var getProfileDetails = function () {
        var clientProfileRequestPayload = {
            clientId: props === null || props === void 0 ? void 0 : props.clientId,
            page: "1",
            pageSize: "10",
        };
        di.leads.updateClientProfileDetails(clientProfileRequestPayload);
    };
    var getFileName = function (fileId, index, splitString) {
        var subSplitString = splitString.split(";")[0].split(":")[1];
        return ("Download_image_" +
            index.toString() +
            getImageFileExtension(subSplitString));
    };
    // const getClientImagesForPic = () => {
    //   let reqObj: IClientPictureRequestPayload = {
    //     type: "GET",
    //     acCode: props.clientId,
    //     page: 1,
    //     pageSize: 50,
    //     isGetAll: true,
    //   };
    //   di.leads
    //     .getClientProfilePicture(reqObj)
    //     .then((imageResp: IClientPictureEntity) => {
    //       if (imageResp.data && imageResp.data.length > 0) {
    //         let tempList: any[] = [];
    //         imageResp.data.map((record: IClientPictureGetALL) => {
    //           if (record?.uploadType !== "Client_Profile") {
    //             let base64Record: {
    //               base64String: string;
    //               fileId?: string;
    //             } = {
    //               base64String: getImageString(record.fileStream),
    //               fileId: record.fileId,
    //             };
    //             tempList.push(base64Record);
    //           }
    //         });
    //         if (tempList.length > 0) setDisplayList(tempList);
    //       }
    //     });
    // };
    var uploadImagesForClient = function (uploadType, tempList) {
        var fileStream = [];
        if (base64StringArray.length > 0) {
            base64StringArray.map(function (record) {
                var fileStreamObj = {
                    imageString: record.base64String.split(",")[1],
                    fileName: record.file.name,
                    uploadType: imgType,
                };
                fileStream.push(fileStreamObj);
            });
        }
        var reqObj = {
            type: "POST",
            acCode: props.clientId,
            fileStream: tempList && tempList.length > 0 ? tempList : fileStream,
        };
        di.leads.getClientProfilePicture(reqObj).then(function (uploaded) {
            setBase64String([]);
            setOpenImageOptions(false);
            props.getClientImagesForPic();
        });
    };
    var removeProfilePic = function (fileId, index) {
        var reqObj = {
            type: "PUT",
            acCode: props.clientId,
            fileid: fileId,
        };
        di.leads.getClientProfilePicture(reqObj).then(function (uploaded) {
            setDisplayList(function (_a) {
                var _b = __read(_a), displayList = _b.slice(0);
                displayList.splice(index, 1);
                return displayList;
            });
        });
    };
    var downloadProfilePicture = function (base64String, index, fileId) {
        var splitString = base64String.split(",");
        if (splitString.length > 0) {
            if (getFileName(fileId, index, splitString[0]))
                downloadBase64Image(base64String, getFileName(fileId, index, splitString[0]));
        }
    };
    var routeToViewProfile = function () {
        var url = new URL(process.env.VIEW_PROFILE_IMAGE);
        url.searchParams.append("AcCode", props.clientId);
        url.searchParams.append("LoginId", userId.toString());
        window.open(url.toString(), "_blank");
    };
    React.useEffect(function () {
        getProfileDetails();
        getClientPurchaseHistory();
        props.getClientImagesForPic();
    }, []);
    React.useEffect(function () {
        if (isReadyToUpload &&
            base64StringArray.length > 0 &&
            base64StringArray.length === selectedFilesLength &&
            !!imgType) {
            uploadImagesForClient();
        }
    }, [isReadyToUpload, base64StringArray]);
    React.useEffect(function () {
        if (props.imgList && props.imgList.length > 0) {
            setDisplayList(props.imgList);
        }
        else {
            setDisplayList([]);
        }
    }, [props.imgList]);
    return (React.createElement("div", { className: "profile-overview-block" },
        clientProfileCommonData.loader && React.createElement(Loader, null),
        ((_a = clientProfileCommonData === null || clientProfileCommonData === void 0 ? void 0 : clientProfileCommonData.errorData) === null || _a === void 0 ? void 0 : _a.isOpen) && (React.createElement(ErrorNotification, { error: (_b = clientProfileCommonData === null || clientProfileCommonData === void 0 ? void 0 : clientProfileCommonData.errorData) === null || _b === void 0 ? void 0 : _b.error, isOpen: (_c = clientProfileCommonData === null || clientProfileCommonData === void 0 ? void 0 : clientProfileCommonData.errorData) === null || _c === void 0 ? void 0 : _c.isOpen, displayType: ErrorDisplayType.INSECTION, refresh: function () { } })),
        !((_d = clientProfileCommonData === null || clientProfileCommonData === void 0 ? void 0 : clientProfileCommonData.errorData) === null || _d === void 0 ? void 0 : _d.isOpen) && (React.createElement(React.Fragment, null, clientProfileDetails.clientProfile &&
            clientProfileDetails.clientProfile.length > 0 &&
            clientProfileDetails.clientProfile.map(function (items) {
                var _a, _b;
                return (React.createElement(React.Fragment, null,
                    React.createElement(Row, { className: "mx-0  profile-over-tile" },
                        React.createElement(Col, { className: "px-0 DMSansMedium_12_500 txt_secondary-gray", lg: 5, md: 5 }, items === null || items === void 0 ? void 0 : items.title),
                        React.createElement(Col, { className: "px-0 DMSans_13_500  txt_blackOne1", lg: 7, md: 7 },
                            ((_b = (_a = items === null || items === void 0 ? void 0 : items.value) === null || _a === void 0 ? void 0 : _a.toString()) === null || _b === void 0 ? void 0 : _b.includes("@")) ? (React.createElement("span", { className: "text-decoration-underline" }, items === null || items === void 0 ? void 0 : items.value)) : (items === null || items === void 0 ? void 0 : items.value),
                            (items === null || items === void 0 ? void 0 : items.tag) ? (React.createElement("span", { className: "dnd-tag DMSans_13_500" }, items === null || items === void 0 ? void 0 : items.tagValue)) : (""),
                            items.view360Link ? (React.createElement(React.Fragment, null,
                                " ",
                                items.view360Link &&
                                    typeof items.view360Link === "boolean" && (React.createElement("span", { className: "ps-3 lead-viewprofile DMSanM_14_500 txt-midnight-blue" },
                                    React.createElement(EdALinkButton, { btnTyp: "midnight-blue", LinkHref: props === null || props === void 0 ? void 0 : props.getClientSearchDataList(props === null || props === void 0 ? void 0 : props.clientId, true), 
                                        // onClick={(e: any) => {
                                        //   e.stopPropagation();
                                        //   // getClientSearchDataList(x?.uccCode);
                                        // }}
                                        value: "View 360", className: "txt_black no_bg txt-midnight-blue text-decoration-underline back-url" }))))) : (React.createElement(React.Fragment, null,
                                " ",
                                React.createElement("span", { className: "viewprofile" }, items === null || items === void 0 ? void 0 : items.link))),
                            (items === null || items === void 0 ? void 0 : items.link) ? (React.createElement(React.Fragment, null, items.link && typeof items.link === "boolean" ? (React.createElement(EdButton, { btnTyp: "midnight-blue-underline", type: "button", onClick: function () { return routeToViewProfile(); }, value: "View Profiler", className: "mgl-10 DMSansMedium_16_500" })) : (React.createElement("span", { className: "viewprofile" }, items === null || items === void 0 ? void 0 : items.link)))) : ("")))));
            }))),
        React.createElement(Row, { className: "scroll-image-hr" }, (displayList === null || displayList === void 0 ? void 0 : displayList.length) > 0 &&
            displayList.map(function (fileImageObj, index) {
                return (React.createElement(Col, null,
                    React.createElement("div", { className: "d-flex" },
                        React.createElement("div", { className: "image-display-block hand_cursor" },
                            React.createElement("img", { className: "profile-img", onClick: function () {
                                    downloadProfilePicture(fileImageObj.base64String, index, fileImageObj.fileId);
                                }, src: fileImageObj.base64String }),
                            React.createElement("span", { className: "hand_cursor", onClick: function () {
                                    removeProfilePic(fileImageObj.fileId, index);
                                } },
                                React.createElement("i", { className: "edel-icon-bold-close" }))))));
            })),
        React.createElement(Row, { className: "upload-image-block mx-0 position-relative" },
            React.createElement("label", { className: "flexCenter txt-midnight-blue DMSanM_14_500 hand_cursor", htmlFor: "uploadimg-file", onClick: function () { return setOpenImageOptions(!openImageOptions); } },
                "Upload Image",
                React.createElement("i", { className: "edel-icon-arrow-down ms-2" })),
            openImageOptions && React.createElement(ImagePopup, { onSelectFile: onSelectFile }),
            profilePicError && (React.createElement("p", { className: "help_text red" }, "Selected File should be less than 5mb. please select proper file."))),
        React.createElement(Row, { className: "mx-0 purchase-history-block" },
            React.createElement("div", { className: "flexJustifySpaceBetween px-0" },
                React.createElement("div", { className: "DMSan_16_700 txt-midnight-blue" }, "Purchase History"))),
        React.createElement(Row, { className: "m-0 table-block" }, !clientPurchaseHistoryCommonData.errorData.isOpen ? (React.createElement(React.Fragment, null,
            React.createElement(GenericTable, { columns: props.columns, loader: clientPurchaseHistoryCommonData.loader, data: clientPurchaseHistory.data }),
            React.createElement("div", { className: "Errormsgdiv" }, (clientPurchaseHistoryCommonData === null || clientPurchaseHistoryCommonData === void 0 ? void 0 : clientPurchaseHistoryCommonData.message) &&
                ((_e = clientPurchaseHistoryCommonData === null || clientPurchaseHistoryCommonData === void 0 ? void 0 : clientPurchaseHistoryCommonData.message) === null || _e === void 0 ? void 0 : _e.show) && (React.createElement(Errormsg, { icon: (_f = clientPurchaseHistoryCommonData === null || clientPurchaseHistoryCommonData === void 0 ? void 0 : clientPurchaseHistoryCommonData.message) === null || _f === void 0 ? void 0 : _f.icon, msg: (_g = clientPurchaseHistoryCommonData === null || clientPurchaseHistoryCommonData === void 0 ? void 0 : clientPurchaseHistoryCommonData.message) === null || _g === void 0 ? void 0 : _g.msg }))))) : (React.createElement(ErrorNotification, { error: (_h = clientPurchaseHistoryCommonData === null || clientPurchaseHistoryCommonData === void 0 ? void 0 : clientPurchaseHistoryCommonData.errorData) === null || _h === void 0 ? void 0 : _h.error, isOpen: (_j = clientPurchaseHistoryCommonData === null || clientPurchaseHistoryCommonData === void 0 ? void 0 : clientPurchaseHistoryCommonData.errorData) === null || _j === void 0 ? void 0 : _j.isOpen, displayType: ErrorDisplayType.INSECTION, refresh: function () { } })))));
};
export default ProfileOverview;
